"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var string_1 = require("@celo/base/lib/string");
// Exports moved to @celo/base, forwarding them
// here for backwards compatibility
var string_2 = require("@celo/base/lib/string");
exports.appendPath = string_2.appendPath;
exports.normalizeAccents = string_2.normalizeAccents;
exports.StringUtils = {
    appendPath: string_1.appendPath,
    normalizeAccents: string_1.normalizeAccents,
};
//# sourceMappingURL=string.js.map